import * as CustomModuleIcons from '../../../Icons/CustomModuleIcons';

export const CustomModuleCards = [
  {
    name: 'Airtable',
    description:
      'Connect an Airtable grid, form, calendar, gallery, kanban, timeline, or gantt view.',
    instructions:
      'Airtable is a popular Extension that can be used for many use cases. For example, you can embed an intake form or you can embed a project tracking kanban board for each client. To embed a page from Airtable click on “Share view” and then “Embed this view on your site”. Then configure the embed and copy the embed code snippet.',
    icon: CustomModuleIcons.AirtableIcon,
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8054003700635-How-do-you-connect-Airtable-as-an-Extension-',
  },
  {
    name: 'Calendly',
    description: 'Make it easy for your clients to schedule time with you.',
    instructions:
      'With Calendly, make it easy for clients to schedule time with your team. If every client should be able to schedule time with the same person, set up a global Extension. If the rules are more nuanced (maybe only some clients should be able to schedule or maybe different clients should be paired with different internal users) set up a local or custom Extension. To embed Calendly, you can simply insert the URL of your scheduling link.',
    icon: CustomModuleIcons.CalendlyIcon,
    learnMoreLink:
      ' https://support.copilot.com/hc/en-us/articles/8037987724059-How-do-you-connect-Calendly-as-an-Extension-',
  },
  {
    name: 'Loom',
    description:
      'Make the client experience more engaging by adding a welcome video, tutorial series, or other video content.',
    instructions:
      'Make the experience for clients more engaging with videos. Videos are great for training - company introductions, tutorials, and more. To embed Loom, insert the public URL.',
    icon: CustomModuleIcons.LoomIcon,
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474615831323-How-do-you-connect-Loom-as-an-Extension-',
  },
  {
    name: 'YouTube',
    description:
      'Make the client experience more engaging by adding a welcome video, tutorial series, or other video content.',
    instructions:
      'Make the experience for clients more engaging with videos. Videos are great for training - company introductions, tutorials, and more. To embed YouTube insert the public URL.',
    icon: CustomModuleIcons.YoutubeIcon,
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474995305883-How-do-you-connect-YouTube-as-an-Extension-',
  },
  {
    name: 'ClickUp',
    description:
      'Connect a ClickUp list, board, calendar, timeline, or one of several other views.',
    instructions:
      'ClickUp is a flexible tool with many different types of views. For example, you can embed a form that clients can fill out, embed a calendar with important dates, or embed a Kanban board that shows clients how their projects are progressing. To embed a page from ClickUp, click on “Share”, enable the public link option, and use the embed code.',
    icon: CustomModuleIcons.ClickUpIcon,
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8054111067163-How-do-you-connect-ClickUp-as-an-Extension-',
  },
  {
    name: 'Jotform',
    description:
      'Connect a Jotform form and let clients fill it out directly in your portal.',
    instructions:
      'Jotform is popular tool that helps you create powerful forms with conditional logic and more. To embed a form from Jotform, click on “Publish” at the top of the form builder, go to the embed section, select the iFrame option, click on “Copy code”, and insert it.',
    icon: CustomModuleIcons.JotformIcon,
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474732370587-How-do-you-connect-Jotform-as-an-Extension-',
  },
  {
    name: 'Typeform',
    icon: CustomModuleIcons.TypeformIcon,
    description:
      'Connect a Typeform form and let clients fill it out directly in your portal.',
    instructions:
      'Typeform lets you create beautiful modern forms with pagination, conditional logic and more. To embed a form from Typeform, insert the URL of the form.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474354741531-How-do-you-connect-Typeform-as-an-Extension-',
  },
  {
    name: 'Google Data Studio',
    icon: CustomModuleIcons.GoogleDataStudioIcon,
    description:
      'Connect a dashboard from Google Data Studio so that clients can access visualizations from a unified place.',
    instructions:
      'If you have a dashboard in Google Data Studio, consider embedding it in your portal so that clients can access it directly from your portal. If you have multiple dashboards you can combine them on Google Data Studio and connect one Extension, or you can add multiple Extensions. To embed Google Data Studio, edit your report, share the report and make sure it’s set to “Public on the web” or “Anyone with the link can view”, go to  “File” > “Embed report”, click “Enable embedding”, select the “Embed code” option, click “Copy to clipboard”, and insert it.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8054903309211-How-do-you-connect-Google-Data-Studio-as-an-Extension-',
  },
  {
    name: 'Databox',
    icon: CustomModuleIcons.DataboxIcon,
    description:
      'Connect a dashboard from Databox so that clients can access visualizations from a unified place.',
    instructions:
      'If you have a dashboard in Databox, consider embedding it in your portal so that clients can access it directly from your portal. If you have multiple dashboards you can combine them on Databox and connect one Extension, or you can add multiple Extensions. To embed a Databoard, navigate to the Databoards page, hover on the Databoard you want to connect, click on “Share Databoard”, click on the “Embed” tab at the top of the “Share Databoard” window, click on the green “Copy code” button, and insert it.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474895757723-How-do-you-connect-Databox-as-an-Extension-',
  },
  {
    name: 'Power BI',
    icon: CustomModuleIcons.PowerBIIcon,
    description:
      'Connect a dashboard from Power BI so that clients can access visualizations from a unified place.',
    instructions:
      'If you have a dashboard in Power BI, consider embedding it in your portal so that clients can access it directly from your portal. If you have multiple dashboards you can combine them on Power BI and connect one Extension, or you can add multiple Extensions. To embed a dashboard from Power BI, go to “File” > “Embed report” > “Publish to web (public)”, click on “Create embed code”, click on “Publish”, copy the snippet beside where it says “HTML you can paste into a website”, and insert it.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474823056027-How-do-you-connect-Power-BI-as-an-Extension-',
  },
  {
    name: 'Google Sheets',
    icon: CustomModuleIcons.GoogleSheetsIcon,
    description:
      'Connect a spreadsheet from Google Sheets with view-only or edit permissions for your clients.',
    instructions:
      'Google Sheets is a powerful web-based spreadsheet tool. In your sharing settings you can specify if those who have access to the link can view only or can also edit. To embed a Google Sheet, click on “Share”, click on “Change” in the link section, select the option “Anyone with the link” can view, and then insert the URL.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474814419995-How-do-you-connect-Google-Sheets-as-an-Extension-',
  },
  {
    name: 'Google Docs',
    icon: CustomModuleIcons.GoogleDocsIcon,
    description:
      'Connect a document from Google Docs with view-only or edit permissions for your clients.',
    instructions:
      'Google Docs is a powerful web-based document editing tool. In your sharing settings you can specify if those who have access to the link can view only or can also edit. To embed a Google Doc, click on “Share”, click on “Change” in the link section, select the option “Anyone with the link” can view, and then insert the URL.',
    learnMoreLink:
      'https://support.copilot.com/hc/en-us/articles/8474794731419-How-do-you-connect-Google-Docs-as-an-Extension-',
  },
];

type CustomModuleCard = typeof CustomModuleCards[number];

/**
 * Return a custom module card by name
 * @param moduleName the custom module name to find in the custom module cards
 * @returns a custom module card object if found, otherwise null
 */
export const getCustomModuleCard = (moduleName: string) =>
  CustomModuleCards.find(card => card.name === moduleName);
